/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar-check-stroke': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<desc>event date time appointment done</desc><g stroke-width="1.5" _stroke="currentColor" _fill="none" stroke-linejoin="round"><rect pid="0" width="22.5" height="19.5" x=".75" y="3.75" rx="1.5"/><path pid="1" d="M.75 9.75h22.5"/><g stroke-linecap="round"><path pid="2" d="M6.75 6V.75M17.25 6V.75M15.75 13.5l-4.5 6-3-3"/></g></g>'
  }
})
